function asId(value) {
  return String(value ?? '').trim()
}

function mapWalletById(record = {}) {
  return Object.entries(record).reduce((acc, [id, entry]) => {
    const key = asId(id)
    if (!key || !entry) {
      return acc
    }
    acc[key] = {
      id: key,
      key: asId(entry.key),
      name: asId(entry.name),
      description: asId(entry.description),
    }
    return acc
  }, {})
}

function mapAccountById(record = {}) {
  return Object.entries(record).reduce((acc, [id, entry]) => {
    const key = asId(id)
    if (!key || !entry) {
      return acc
    }
    acc[key] = {
      id: key,
      walletId: asId(entry.wallet_id ?? entry.walletId),
      walletKey: asId(entry.wallet_key ?? entry.walletKey),
      currencyCode: asId(entry.currency_code ?? entry.currencyCode ?? entry.currency).toLowerCase(),
      name: asId(entry.name),
      description: asId(entry.description) || null,
    }
    return acc
  }, {})
}

function mergeWalletList(walletById, wallets = []) {
  for (const wallet of wallets) {
    const id = asId(wallet?.id)
    if (!id || walletById[id]) {
      continue
    }
    walletById[id] = {
      id,
      key: asId(wallet.key),
      name: asId(wallet.name),
      description: asId(wallet.description),
    }
  }
  return walletById
}

function mergeAccountList(accountById, accounts = []) {
  for (const account of accounts) {
    const id = asId(account?.id)
    if (!id || accountById[id]) {
      continue
    }
    accountById[id] = {
      id,
      walletId: asId(account.wallet_id ?? account.walletId),
      walletKey: asId(account.wallet_key ?? account.walletKey),
      currencyCode: asId(account.currency_code ?? account.currencyCode ?? account.currency).toLowerCase(),
      name: asId(account.name),
      description: asId(account.description) || null,
    }
  }
  return accountById
}

export function mapAdminSystemWalletsPayload(payload) {
  const data = payload?.data ?? {}
  const walletById = mergeWalletList(mapWalletById(data.wallet_by_id), data.wallets)
  const accountById = mergeAccountList(mapAccountById(data.account_by_id), data.accounts)
  return {
    walletById,
    accountById,
  }
}
